import * as React from "react";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { Box, Button, Tooltip } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
      color: "black",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const ColorBox = ({ color, label }) => (
  <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
    <div style={{ backgroundColor: color, width: "15px", height: "15px" }}></div>
    &nbsp; &nbsp; <p>{label}</p>
  </div>
);

const Help = () => {
  const [expanded, setExpanded] = React.useState("panel1");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <>
      {/* Accordion for Certificate Colors */}
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        sx={{ boxShadow: "1px 1px 5px #000" }}
      >
        <AccordionSummary
          aria-controls="panel1d-content"
          id="panel1d-header"
          sx={{ backgroundColor: "#ccc"}}
        >
          <Typography>Color Code</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ display: "flex", alignItems: "start", paddingLeft: "20px", flexDirection: "column" }}>
            <ColorBox color="#22c9b0" label="Observation Sheet Tested By" />
            <ColorBox color="#6CE796" label="Certificate Prepared By" />
            <ColorBox color="#F392F3" label="Certificate Reviewed By" />
            <ColorBox color="#A0A0F7" label="Certificate Authorised By" />
            <ColorBox color="#FF3F33" label="Certificate Reject" />
            <ColorBox color="#37AFE1" label="Srf Approved" />
          </Box>
        </AccordionDetails>
      </Accordion>
    

      <div style={{ textAlign: "left", margin: "20px 0px" }}>
        <h5>Application Term Glossary</h5>
        <br />
        <h6>NA : Not Available</h6>
        <h6>"-" : Not Required</h6>
      </div>

      <div style={{ textAlign: "left", margin: "20px 0px" }}>
        <h5>Inward Approved</h5>
        <div style={{display:"flex",alignItems:"center",marginTop:"5px"}}>
        <Button size="small">
           <CheckCircleIcon />
        </Button>
        <h6>Inward Not Approved</h6>
        </div>
        <div style={{display:"flex",alignItems:"center"}}>
        <Button size="small" disabled>
           <CheckCircleIcon />
        </Button>
        <h6>Inward Approved</h6>
        </div>
      </div>
    </>
  );
};

export default Help;
